import useScreenSize from "../../context/ScreenContext";
import { Theme } from "../../data/style/Theme";

const ToggleButton = ({ items, setId, id }) => {
  const { mobileDevice } = useScreenSize();
  return (
    <div
      style={{
        display: "flex",
        background: Theme.palette.card,
        borderRadius: 99,
        padding: mobileDevice ? 2 : 3,
        border: `1px solid ${Theme.palette.border}`,
        gap: 3,
      }}
    >
      {items.map((item) => (
        <button
          key={item.id}
          onClick={() => setId(item.id)}
          style={{
            padding: mobileDevice ? "5px 10px" : "5px 14px",
            borderRadius: 99,
            border: "none",
            background:
              id === item.id
                ? "linear-gradient(135deg,#f97316,#ea580c)"
                : "transparent",
            fontFamily: "Oswald, sans-serif",
            fontWeight: 700,
            fontSize: mobileDevice ? "0.7rem" : "0.8rem",
            color: id === item.id ? "#fff" : Theme.palette.muted,
            cursor: "pointer",
            transition: "all .18s",
            letterSpacing: "0.05em",
          }}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleButton;
